export enum RUMPage {
    INCIDENT_DETAIL = "/incident-model/",
    COLLAB_SPACE = '/incident-model/{incId}/collaboration',
    FEED = "/feed",
    RECORD_MGMT = "/records-management",
    DASHBOARD = "/dashboard",
    ADMIN = "/admin",
    EVENT_MGMT = "/event-management",
  }
  